import { render, staticRenderFns } from "./IyLayout.vue?vue&type=template&id=a87958d4&"
import script from "./IyLayout.vue?vue&type=script&lang=js&"
export * from "./IyLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/iy_web_test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a87958d4')) {
      api.createRecord('a87958d4', component.options)
    } else {
      api.reload('a87958d4', component.options)
    }
    module.hot.accept("./IyLayout.vue?vue&type=template&id=a87958d4&", function () {
      api.rerender('a87958d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/IyLayout.vue"
export default component.exports